const getAuthConfigByPageType = (authKey: string) => {
  const configMap = {
    clueList: {
      viewPhoneKey: 'clueViewPhone',
      editPhoneKey: 'clueEditPhone',
      editCustomerChannelKey: 'customerChannelModificationPermissions',
      isWorkBench: true,
    },
    clueListSale: {
      viewPhoneKey: 'salePlanViewPhone',
    },
    call: {
      viewPhoneKey: 'callViewPhone',
      isPublicSea: true
    },
    sale: {
      viewPhoneKey: 'salePublicInfoViewPhone',
      isPublicSea: true
    },
    design: {
      viewPhoneKey: 'DesignPublicInfoViewPhone',
      isPublicSea: true
    },
  }
  return configMap[authKey] || {
    viewPhoneKey: 'salesWorkBenchClueViewPhone',
    editPhoneKey: 'salesWorkBenchClueEditPhone',
    editKey: 'salesWorkBenchClueInfoEdit',
    editCustomerChannelKey: 'salesWorkBenchCustomerChannelModificationPermissions',
    isWorkBench: true,
  }
}

export default getAuthConfigByPageType;